import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Dialog,
  makeStyles,
  IconButton,
  SvgIcon,
  Typography,
  Button,
  DialogContent,
  DialogActions,
  Divider,
  useMediaQuery,
} from '@material-ui/core';
import ButtonPrimary from '../../components/Button/ButtonPrimary';
import ButtonSecondary from '../../components/Button/ButtonSecondary';
import { useHistory } from 'react-router-dom';
import QrReader from "react-qr-scanner";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '10px'
  },
  inputRoot: {
    "& .MuiInputBase-root ": {
      height: "46px",
      paddingLeft: '15px',
      paddingTop: '5px'
    },
  },
  icon: {
    marginRight: 10,
  },
  btn: {
    background: '#28a745 0% 0% no-repeat padding-box',
    color: 'white',
    fontWeight: 600,
    '&:hover': {
      background: '#1C9F3A 0% 0% no-repeat padding-box',
      color: 'white'
    },
    boxShadow:
      '0 0px 0px 0 rgb(0 0 0 / 10%), 0 1px 1px -1px rgb(0 0 0 / 5%), 0 1px 3px 0 rgb(0 0 0 / 10%)'
  }
}));

const DialogQr = ({
  onClose,
  open,
  text,
  textBtn,
  onSubmit,
  ...rest
}) => {
  const classes = useStyles();
  
  const handleScan = async (scanData) => {
    if (scanData) {
        let splits = scanData.split('/');
        onSubmit(splits[splits.length - 1]);
    }
  };

  const handleError = (err) => {
    onSubmit('error');
  };

  return (<>
    <Dialog
      onClose={onClose}
      open={open}
      maxWidth="xs"
      fullWidth
      {...rest}
    >
      <DialogContent>
        <Box mx={2} my={2} mb={3}>
          <QrReader
            delay={300}
            onError={handleError}
            onScan={handleScan}
            style={{ width: "100%" }}
            facingMode="environment"
          />
        </Box>
      </DialogContent>
      <DialogActions style={{ display:'flex', justifyContent:'center' }}>
        <Box mt={1} mb={3}>
          <ButtonPrimary
            title={'ยกเลิก'}
            onClick={() => onClose()}
            style={{ width: 240 }}
          />
        </Box>
      </DialogActions>
    </Dialog>
  </>)
}

DialogQr.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired
};

DialogQr.defaultProps = {
  open: false,
  onClose: () => {}
};

export default DialogQr;